/**
 * @author Maxim Seredkin
 * @param {uiSelectConfig} uiSelectConfig
 */
export default ['uiSelectConfig',
    function(uiSelectConfig) {
        uiSelectConfig.theme = 'bootstrap';
        uiSelectConfig.resetSearchInput = true;
        uiSelectConfig.appendToBody = true;
    }];
